<template>
    <v-container>
        <period-selector v-if="$vuetify.breakpoint.mdAndDown"></period-selector>

        <div class="headline font-weight-light text-center my-6">
            Terima kasih telah mendaftar {{ $store.get('enrollment/selected@title') }}

            <template v-if="$store.get('enrollment/selected@is_trial')">
                (Trial)
            </template>
        </div>

        <v-skeleton-loader v-if="isLoading" type="image"></v-skeleton-loader>

        <specific-tryout
            v-else-if="$store.get('enrollment/selected@is_specific') || $store.get('enrollment/selected@special')"
            :payment="payment"
        ></specific-tryout>

        <trial-tryout
            v-else-if="$store.get('enrollment/selected@is_trial')"
            :payment="payment"
        >
        </trial-tryout>

        <paid-tryout v-else :payment="payment"></paid-tryout>
    </v-container>
</template>

<script>
import PaidTryout from './components/PaidTryout'
import PeriodSelector from '@/components/dashboard/period/PeriodSelector'
import SpecificTryout from './components/SpecificTryout'
import TrialTryout from './components/TrialTryout'

export default {
    components: {
        PaidTryout,
        PeriodSelector,
        SpecificTryout,
        TrialTryout,
    },

    data() {
        return {
            payment: null,
            paymentError: false,
            isLoading: true,
            registrationLink: null
        }
    },

    async created() {
        if (this.$store.get('enrollment/selected@is_active')) {
            return this.$router.replace({ name: 'dashboard' })
        }

        const response = await this.$api.get('payment')
        this.payment = response.data

        const registrationLinkSlug = this.$store.get('enrollment/selected@registration_link_slug')
        if (registrationLinkSlug) {
            const registrationLinkResponse = await this.$apiv2.get(`registration-link/${registrationLinkSlug}`)
            this.registrationLink = registrationLinkResponse.data

            if (this.registrationLink.specialRequirement) {
                const selectedIdx = this.$store.get('enrollment/selectedIdx')
                this.$store.set(`enrollment/enrollments@${selectedIdx}.is_specific`, true)
                this.$store.set(`enrollment/enrollments@${selectedIdx}.requirement`, this.registrationLink.specialRequirement)
            }
        }

        this.isLoading = false
    },
}
</script>
